import React, { useEffect, useState } from 'react';
import './SmartImage.css';

function SmartImage({
  src,
  fallbackSrc,
  alt,
  className = '',
  loading = 'lazy',
  decoding = 'async'
}) {
  const [currentSrc, setCurrentSrc] = useState(src);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setCurrentSrc(src);
    setFailed(false);
  }, [src, fallbackSrc]);

  const handleError = () => {
    if (fallbackSrc && currentSrc !== fallbackSrc) {
      setCurrentSrc(fallbackSrc);
      return;
    }
    setFailed(true);
  };

  if (failed) {
    return (
      <div className={`${className} smart-image smart-image--fallback`} role="img" aria-label={alt}>
        <span>{alt}</span>
      </div>
    );
  }

  return (
    <img
      src={currentSrc}
      alt={alt}
      className={`${className} smart-image`}
      loading={loading}
      decoding={decoding}
      onError={handleError}
    />
  );
}

export default SmartImage;
